import mutation_types from "./mutation_types.js";

export default {
    [mutation_types.SET_CONTRACT_FORM](state, data) {
        Object.assign(state.contractForm, data);
    },
    [mutation_types.CLEAR_CONTRACT_FORM](state) {
        state.contractForm = {};
    },
    [mutation_types.SET_THRESHOLD](state, payload) {
        state.threshold = payload;
    }
}
